// Safe to store in a log or a PostHog property: a card-like run of digits never
// lands there, and one value stays one short piece of one line.
export const clean = (text, max = 200) => String(text == null ? '' : text)
  .replace(/\d{6,}/g, '#')
  .replace(/[\r\n|]+/g, ' ')
  .trim()
  .slice(0, max);
